
export default function CompetitiveEdge() {
  const edges = [
    {
      icon: 'ri-vip-diamond-line',
      title: 'Strictly Curated',
      description: 'Only Vancouver\'s most interesting, influential, or well-connected individuals are accepted. No exceptions.'
    },
    {
      icon: 'ri-building-4-line',
      title: 'Luxury Events Only',
      description: 'Private venue takeovers, rooftop socials, and yacht experiences at Vancouver\'s most exclusive locations.'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Where Vancouver\'s Elite Connect',
      description: 'Models, influencers, entrepreneurs, athletes, and socialites - Vancouver\'s top tier all in one network.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Curated Connections',
      description: 'Direct access to the people who drive impact in Vancouver - from business to social influence.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Elevate Your Status',
      description: 'Membership signals you\'ve made it. Association with Clique increases your social and professional currency in Vancouver.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Brand Partnerships & Perks',
      description: 'Access to exclusive brand collaborations, sponsorships, and premium opportunities unavailable to the public.'
    }
  ];

  return (
    <section className="bg-gradient-to-br from-gray-900 via-black to-gray-900 px-6 py-32">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <div className="mb-6 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
          <h2 className="mb-6 font-serif text-4xl font-light text-white md:text-5xl lg:text-6xl">
            Why Clique Is <span className="italic">Different</span>
          </h2>
          <p className="text-lg text-gray-400">
            Not just another community - a true unfair advantage.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {edges.map((edge, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden border border-gray-800 bg-black p-8 transition-all duration-300 hover:border-amber-400 cursor-pointer"
            >
              <div className="absolute right-0 top-0 h-32 w-32 translate-x-16 -translate-y-16 bg-amber-400 opacity-0 blur-3xl transition-all duration-500 group-hover:opacity-20" />
              
              <div className="relative z-10">
                <div className="mb-6 flex h-12 w-12 items-center justify-center border border-amber-400">
                  <i className={`${edge.icon} text-2xl text-amber-400`}></i>
                </div>
                <h3 className="mb-4 text-xl font-medium text-white">
                  {edge.title}
                </h3>
                <p className="leading-relaxed text-gray-400">
                  {edge.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <div className="mx-auto max-w-3xl border-l-4 border-amber-400 bg-gray-900 p-10">
            <p className="text-2xl font-light leading-relaxed text-gray-300">
              Clique isn't about quantity - it's about <span className="font-medium text-white">quality, exclusivity, and access.</span> Membership is highly selective and spots are limited.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
